









import { BaseSelect, selectName } from '#components/baseSelect';

import { NAME as ConstName } from '../constants';
import { apiProvider } from '../api';

type DataType = {
	SERVICE_PACKAGE_ID: number;
	NAME: string;
	CATEGORY_NAME: string;
	SERVICE_ORDER_TYPE: string;
	PACKAGE_TYPE: string;
};

export default BaseSelect.extend({
	name: selectName(ConstName),
	props: {
		labelKey: { type: String, default: 'SERVICE_PACKAGE_ID' },
		isClearable: { type: Boolean, default: true },
	},
	data() {
		return {
			storeObject: ConstName,
			valueFieldName: 'SERVICE_PACKAGE_ID',
			apiProvider,
			emptyObject: {
				isClear: true,
				value: null,
				text: null,
				Name: null,
				ServicePackageId: null,
				ServicePackageTxt: null,
				CategoryName: null,
				ServiceOrderType: null,
				PackageType: null,

			},
		};
	},
	methods: {
		dbToBaseMapper(data: DataType) {
			return {
				value: data.SERVICE_PACKAGE_ID,
				text: data.NAME,
				Name: data.NAME,
				ServicePackageId: data.SERVICE_PACKAGE_ID,
				ServicePackageTxt: data.NAME,
				CategoryName: data.CATEGORY_NAME,
				ServiceOrderType: data.SERVICE_ORDER_TYPE,
				PackageType: data.PACKAGE_TYPE,
			};
		},
	},
});
